import PropTypes from 'prop-types';
import { Children, isValidElement } from 'react';
import classNames from 'classnames';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var Menu = function Menu(_ref) {
  var open = _ref.open,
    bottom = _ref.bottom,
    top = _ref.top,
    left = _ref.left,
    right = _ref.right,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-menu', className, {
      open: open,
      bottom: bottom,
      top: top,
      left: left,
      right: right
    }),
    style: {
      height: open ? Children.toArray(children).filter(function (child) {
        return /*#__PURE__*/isValidElement(child);
      }).length * 2 + 'rem' : 0
    },
    onClick: function onClick(e) {
      e.preventDefault();
    },
    children: children
  });
};
Menu.propTypes = {
  bottom: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  left: PropTypes.bool,
  open: PropTypes.bool,
  right: PropTypes.bool,
  top: PropTypes.bool
};
export default Menu;
export var MenuItem = function MenuItem(_ref2) {
  var selected = _ref2.selected,
    disabled = _ref2.disabled,
    className = _ref2.className,
    children = _ref2.children,
    _onClick = _ref2.onClick;
  var content = Children.map(children, function (child) {
    if (typeof child === 'string') {
      return /*#__PURE__*/_jsx("div", {
        className: "ptr-menu-item-caption",
        children: child
      });
    } else {
      return child;
    }
  });
  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-menu-item', className, {
      selected: selected,
      disabled: disabled
    }),
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);
      e.preventDefault();
    },
    children: content
  });
};
MenuItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool
};